import {Expose} from 'class-transformer';

export class CardTypeValueApiModel {
  @Expose()
  paymentValue: number;

  @Expose()
  bonusValue: number;
}
